import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL || `${window.location.origin}/api`;

const handleResponse = (response) => {
  if (response?.data) return response.data;
  return { isSuccess: false, resultMessage: 'Beklenmeyen cevap alındı.' };
};

const basePath = '/fitness';

export const fitnessAppointmentSettings = {
  getSettings: async () => {
    try {
      const res = await axios.get(`${baseUrl}${basePath}/settings`);
      return handleResponse(res);
    } catch (e) { return { isSuccess: false, resultMessage: 'Hata' }; }
  },
  getAvailability: async (date) => {
    try {
      const res = await axios.get(`${baseUrl}${basePath}/availability`, { params: { date } });
      return handleResponse(res);
    } catch (e) { return { isSuccess: false, resultMessage: 'Hata' }; }
  },
  getBlockedSlots: async (date) => {
    try {
      const res = await axios.get(`${baseUrl}${basePath}/blocked-slots`, { params: { date } });
      return handleResponse(res);
    } catch (e) { return { isSuccess: false, resultMessage: 'Hata' }; }
  },
  requestAppointment: async (data) => {
    try {
      const res = await axios.post(`${baseUrl}${basePath}/request`, data);
      return handleResponse(res);
    } catch (e) { return { isSuccess: false, resultMessage: e?.response?.data?.resultMessage || 'Hata' }; }
  },
  confirmAppointment: async (data) => {
    try {
      const res = await axios.post(`${baseUrl}${basePath}/confirm`, data);
      return handleResponse(res);
    } catch (e) { return { isSuccess: false, resultMessage: e?.response?.data?.resultMessage || 'Hata' }; }
  },
};
